const YOUSSEF_USER_ID =
  import.meta.env.VITE_CONVEX_URL.includes("frugal-fly") ||
  import.meta.env.VITE_CONVEX_URL.includes("creatorgrid")
    ? "m17fqm44znk6es5qd0bp1g3ea57gdn8v"
    : "nd7cqm840y3b3pnfjb2jk4aq4n7mb0dg"; // youssef@odyssey.life
const PABLO_USER_ID =
  import.meta.env.VITE_CONVEX_URL.includes("frugal-fly") ||
  import.meta.env.VITE_CONVEX_URL.includes("creatorgrid")
    ? "m178x8x30y6b6sk5wk53jbj4vs7gcqrt"
    : "";
const CREATORS_USER_ID =
  import.meta.env.VITE_CONVEX_URL.includes("frugal-fly") ||
  import.meta.env.VITE_CONVEX_URL.includes("creatorgrid")
    ? "m1714epw5x9v69h66jakkrkd1h7sxrad"
    : "";
const MELINA_USER_ID =
  import.meta.env.VITE_CONVEX_URL.includes("frugal-fly") ||
  import.meta.env.VITE_CONVEX_URL.includes("creatorgrid")
    ? "m172rcpxvmxmzcjd0mfd6y6sj57gvgt3"
    : "";

export const TEAM_USER_IDS = [
  YOUSSEF_USER_ID,
  PABLO_USER_ID,
  MELINA_USER_ID,
  CREATORS_USER_ID,
];
